import React, { useEffect, useState } from "react";
import HeaderPrint from "../../../Pdf/PrintHeaderAccount";
import axios from "axios";
import config from "../../../config";
import { calculateColumnTotal } from "../../Shared/Utility";
import { saleReportStyles } from "../../../Pdf/pdfStyles";
import PrintFooter from "../../../Pdf/PrintFooter";
import { PrintFormateNumber } from "../../../Pdf/PrintFormateNumber";
import {
  PDFViewer,
  Page,
  Text,
  View,
  Document,
} from "@react-pdf/renderer";
import { Spin } from "antd";
import moment from "moment";

const RECEIVABLE_COL = {
  sr: 26,
  name: 120,
  email: 130,
  mobile: 70,
  acType: 80,
  balance: 90,
  type: 51,
};
const RECEIVABLE_TABLE_WIDTH =
  RECEIVABLE_COL.sr +
  RECEIVABLE_COL.name +
  RECEIVABLE_COL.email +
  RECEIVABLE_COL.mobile +
  RECEIVABLE_COL.acType +
  RECEIVABLE_COL.balance +
  RECEIVABLE_COL.type;

const ORDER_LABELS = {
  1: "Name (A-Z)",
  2: "Name (Z-A)",
  3: "Amount (Low-High)",
  4: "Amount (High-Low)",
};

const PrintCashReceivable = () => {
  const UserID = localStorage.getItem("ID");
  const AccessKey = localStorage.getItem("AccessKey");
  const urlParams = new URLSearchParams(window.location.search);

  const EndDate = urlParams.get("EndDate");
  const OrderBy =
    urlParams.get("OrderBy") || urlParams.get("orderby") || "1";
  const includeEmployee = urlParams.get("includeEmployee") === "1";
  const showOnlyEmployee = urlParams.get("showOnlyEmployee") === "1";

  const [cashReceiveableList, setCashReceiveableList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = "Print Cash Receivable";
    setLoading(true);

    const payload = {
      UserID: UserID,
      AccessKey: AccessKey,
      PageNo: 1,
      PageSize: 10000,
      EndDate: EndDate || undefined,
      OrderBy: OrderBy,
      IncludeEmployee: includeEmployee && !showOnlyEmployee,
      ShowOnlyEmployee: showOnlyEmployee,
    };

    axios({
      method: "post",
      url: config.base_url + "Report/GetReceiveableReport",
      headers: { "Content-Type": "application/json" },
      data: payload,
    })
      .then(function (response) {
        if (response.data.status_code == 1) {
          setCashReceiveableList(response.data.listofLedger || []);
        }
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  }, []);

  const totalBalance = calculateColumnTotal(cashReceiveableList, "Balance");

  const scopeLabel = showOnlyEmployee
    ? "Employee accounts only"
    : includeEmployee
    ? "Including employee accounts"
    : "Standard receivable accounts";

  const asOfLabel = EndDate
    ? moment(EndDate).format(config.date_format)
    : moment().format(config.date_format);

  const orderLabel = ORDER_LABELS[Number(OrderBy)] || ORDER_LABELS[1];

  const generateData = () => {
    if (cashReceiveableList.length > 0) {
      return cashReceiveableList.map((item, index) => (
        <View key={index} style={saleReportStyles.row}>
          <View style={[saleReportStyles.td, { width: RECEIVABLE_COL.sr }]}>
            <Text style={saleReportStyles.tdValue}>{index + 1}</Text>
          </View>
          <View style={[saleReportStyles.td, { width: RECEIVABLE_COL.name }]}>
            <Text style={saleReportStyles.tdValue}>{item.Name || "-"}</Text>
          </View>
          <View style={[saleReportStyles.td, { width: RECEIVABLE_COL.email }]}>
            <Text style={saleReportStyles.tdValue}>
              {item.Email_Address || "-"}
            </Text>
          </View>
          <View style={[saleReportStyles.td, { width: RECEIVABLE_COL.mobile }]}>
            <Text style={saleReportStyles.tdValue}>
              {item.Mobile_No || "-"}
            </Text>
          </View>
          <View style={[saleReportStyles.td, { width: RECEIVABLE_COL.acType }]}>
            <Text style={saleReportStyles.tdValue}>
              {item.Account_Type_BE?.Name || "-"}
            </Text>
          </View>
          <View
            style={[
              saleReportStyles.td,
              { width: RECEIVABLE_COL.balance, textAlign: "right" },
            ]}
          >
            <Text style={saleReportStyles.tdValue}>
              {PrintFormateNumber(item.Balance, 0)}
            </Text>
          </View>
          <View style={[saleReportStyles.td, { width: RECEIVABLE_COL.type }]}>
            <Text style={saleReportStyles.tdValue}>
              {item.BalanceType || "-"}
            </Text>
          </View>
        </View>
      ));
    }
  };

  const MyDocument = () => (
    <Document>
      <Page size="A4" style={saleReportStyles.page}>
        <HeaderPrint compact />

        <View style={saleReportStyles.section}>
          <View style={saleReportStyles.titleBlock}>
            <Text style={saleReportStyles.pagetitle}>Cash Receivable Report</Text>
            <Text style={saleReportStyles.reportSubtitle}>
              As of: {asOfLabel}
            </Text>
            <Text style={saleReportStyles.reportSubtitle}>
              Scope: {scopeLabel}    Order: {orderLabel}
            </Text>
          </View>

          <View style={saleReportStyles.table}>
            <View style={saleReportStyles.tableHead}>
              <View style={[saleReportStyles.th, { width: RECEIVABLE_COL.sr }]}>
                <Text style={saleReportStyles.thValue}>Sr. No.</Text>
              </View>
              <View
                style={[saleReportStyles.th, { width: RECEIVABLE_COL.name }]}
              >
                <Text style={saleReportStyles.thValue}>Name</Text>
              </View>
              <View
                style={[saleReportStyles.th, { width: RECEIVABLE_COL.email }]}
              >
                <Text style={saleReportStyles.thValue}>Email</Text>
              </View>
              <View
                style={[saleReportStyles.th, { width: RECEIVABLE_COL.mobile }]}
              >
                <Text style={saleReportStyles.thValue}>Mobile</Text>
              </View>
              <View
                style={[saleReportStyles.th, { width: RECEIVABLE_COL.acType }]}
              >
                <Text style={saleReportStyles.thValue}>A/C Type</Text>
              </View>
              <View
                style={[
                  saleReportStyles.th,
                  { width: RECEIVABLE_COL.balance, textAlign: "right" },
                ]}
              >
                <Text style={saleReportStyles.thValue}>Balance</Text>
              </View>
              <View
                style={[saleReportStyles.th, { width: RECEIVABLE_COL.type }]}
              >
                <Text style={saleReportStyles.thValue}>Type</Text>
              </View>
            </View>

            {generateData()}

            <View style={saleReportStyles.totalsRow}>
              <View
                style={[
                  saleReportStyles.th,
                  {
                    width:
                      RECEIVABLE_TABLE_WIDTH -
                      RECEIVABLE_COL.balance -
                      RECEIVABLE_COL.type,
                    textAlign: "right",
                  },
                ]}
              >
                <Text style={saleReportStyles.thValue}>Total Receivables</Text>
              </View>
              <View
                style={[
                  saleReportStyles.th,
                  { width: RECEIVABLE_COL.balance, textAlign: "right" },
                ]}
              >
                <Text style={saleReportStyles.thValue}>
                  {PrintFormateNumber(totalBalance, 0)}
                </Text>
              </View>
              <View
                style={[saleReportStyles.th, { width: RECEIVABLE_COL.type }]}
              >
                <Text style={saleReportStyles.thValue}></Text>
              </View>
            </View>
          </View>

          <View
            style={{ marginBottom: 20, marginTop: 0, top: 6, bottom: 6 }}
            fixed
          >
            <Text
              style={{ fontSize: "7pt", color: "#000" }}
              render={({ pageNumber, totalPages }) =>
                `Page ${pageNumber} / ${totalPages}`
              }
            />
          </View>
        </View>
        <PrintFooter fixed />
      </Page>
    </Document>
  );

  return (
    <div style={{ width: "100%", height: "100vh", overflow: "hidden" }}>
      {loading ? (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin />
        </div>
      ) : (
        <PDFViewer width="100%" height="100%" fileName="CashReceivable.pdf">
          <MyDocument />
        </PDFViewer>
      )}
    </div>
  );
};

export default PrintCashReceivable;
